import React, { Component } from "react";
import { Input, InputGroup } from "reactstrap";
import { Link } from "react-router-dom";
//simplebar
import SimpleBar from "simplebar-react";

//components
import OnlineUsers from "./OnlineUsers";
import ChatsList from "./ChatsList";

class Chats extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchChat: "",
      recentChatList: [],
      activeTabe: "chats",
    };
    this.handleChange = this.handleChange.bind(this);
    this.openUserChat = this.openUserChat.bind(this);
  }

  componentDidMount() {
    var li = document.getElementById("conversation" + this.props.active_user);
    if (li) {
      li.classList.add("active");
    }
    this.setState({
      recentChatList: this.props.contacts,
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.setState({
        recentChatList: this.props.contacts,
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.recentChatList !== nextProps.recentChatList) {
      this.setState({
        recentChatList: nextProps.contacts,
      });
    }
  }

  addContact = (contact) => {
    const { recentChatList } = this.state;
    const isContact = recentChatList.some((c) => c._id === contact._id);
    if (!isContact) {
      this.setState({ recentChatList: [...recentChatList, contact] });
    }
  };

  handleChange(e) {
    this.setState({ searchChat: e.target.value });
    var search = e.target.value;
    let conversation = this.state.recentChatList;
    let filteredArray = [];

    //find conversation name from array
    for (let i = 0; i < conversation.length; i++) {
      if (
        conversation[i].name.toLowerCase().includes(search) ||
        conversation[i].name.toUpperCase().includes(search)
      )
        filteredArray.push(conversation[i]);
    }

    //set filtered items to state
    this.setState({ recentChatList: filteredArray });

    //if input value is blanck then assign whole recent chatlist to array
    if (search === "") this.setState({ recentChatList: this.props.contacts });
  }

  formatDate(date) {
    const renderNumber = (value, size) => {
      const text = String(value);
      return text.padStart(size, "0");
    };
    const year = renderNumber(date.getFullYear(), 4);
    const month = renderNumber(date.getMonth() + 1, 2);
    const day = renderNumber(date.getDate(), 2);
    return `${day}/${month}/${year}`;
  }

  openUserChat(e, contact) {
    e.preventDefault();

    const id = this.props.contacts.findIndex((c) => c._id === contact._id);

    var chatList = document.getElementById("chat-list");
    var clickedItem = e.target;
    var currentli = null;

    if (chatList) {
      var li = chatList.getElementsByTagName("li");
      // remove coversation user
      for (var i = 0; i < li.length; ++i) {
        if (li[i].classList.contains("active")) {
          li[i].classList.remove("active");
        }
      }
      // find clicked coversation user
      for (var k = 0; k < li.length; ++k) {
        if (li[k].contains(clickedItem)) {
          currentli = li[k];
          break;
        }
      }
    }

    //activation of clicked coversation user
    if (currentli) {
      currentli.classList.add("active");
    }

    var userChat = document.getElementsByClassName("user-chat");
    if (userChat) {
      userChat[0].classList.add("user-chat-show");
    }
    this.props.setActiveUser(id);
    // removes unread badge if user clicks
    var unread = document.getElementById("unRead" + contact._id);
    if (unread) {
      unread.style.display = "none";
    }
  }

  // async onRefresh(props) {
  //   return new Promise((resolve) => {
  //     console.log(props);
  //     props.fetchUpdatedMessages();
  //     setTimeout(resolve, 1000);
  //   });
  // }


  render() {
    const onlineUsers = this.props?.onlineContacts || [];
    const onlineUserIds = onlineUsers.map(user => user._id);

    return (
      <React.Fragment>
        <div style={{ minWidth: 360 }} className="chats-h">
          <div className="px-4 pt-4">
            <h4 className="mb-4">Chats</h4>
            <div className="search-box chat-search-box">
              <InputGroup size="lg" className="mb-3 rounded-lg">
                <span
                  className="input-group-text text-muted bg-light pe-1 ps-3"
                  id="basic-addon1"
                >
                  <i className="ri-search-line search-icon font-size-18"></i>
                </span>
                <Input
                  type="text"
                  value={this.state.searchChat}
                  onChange={(e) => this.handleChange(e)}
                  className="form-control bg-light"
                  placeholder="Search messages or users"
                />
              </InputGroup>
            </div>
            {/* Search Box */}
          </div>

          {/* online users */}
          {this.props?.onlineContacts?.length > 0 && <OnlineUsers contacts={this.props.onlineContacts} openUserChat={this.openUserChat} msgSeenUpdate={this.props.msgSeenUpdate} />}

          {/* chat, contact etc tabs */}
          <div className="mb-3 px-3">
            <ul className="nav nav-pills nav-justified chat-nav-list bg-white">
              <li className="nav-item">
                <Link

                  className={"nav-link " + (this.state.activeTabe === "chats" ? "active" : "")}
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    this.setState({ activeTabe: "chats" });
                  }}
                >
                  <i className="ri-chat-3-line font-size-18"></i> <div className="font-size-11">Chats</div>
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className={"nav-link " + (this.state.activeTabe === "contacts" ? "active" : "")}
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    this.setState({ activeTabe: "contacts" });
                  }}
                >
                  <i className="ri-user-3-line font-size-18"></i> <div className="font-size-11">Contacts</div>
                </Link>
              </li>
              <li className="nav-item">
                <Link

                  className={"nav-link " + (this.state.activeTabe === "groups" ? "active" : "")}
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    this.setState({ activeTabe: "groups" });
                  }}
                >
                  <i className="ri-group-line font-size-18"></i> <div className="font-size-11">Groups</div>
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className={"nav-link " + (this.state.activeTabe === "settings" ? "active" : "")}
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    this.setState({ activeTabe: "settings" });
                  }}
                >
                  <i className="ri-settings-3-line font-size-18"></i> <div className="font-size-11">Settings</div>
                </Link>
              </li>
            </ul>
          </div>
          {/* chat, contact etc tabs end */}

          {this.state.activeTabe === "chats" && (
            <ChatsList
              active_user={this.props.active_user}
              recentChatList={this.state.recentChatList}
              conversations={this.props.conversations}
              formatDate={this.formatDate}
              openUserChat={this.openUserChat}
              msgSeenUpdate={this.props.msgSeenUpdate}
              onlineUsers={onlineUserIds}
            />
          )}

          {this.state.activeTabe === "contacts" && (
            <ChatsList
              active_user={this.props.active_user}
              recentChatList={this.state.recentChatList}
              conversations={this.props.conversations}
              formatDate={this.formatDate}
              openUserChat={this.openUserChat}
              isContact={true}
              addContact={this.addContact}
              onlineUsers={onlineUserIds}
            />
          )}

          {this.state.activeTabe === "groups" && (
            <ChatsList
              active_user={this.props.active_user}
              recentChatList={this.state.recentChatList}
              conversations={this.props.conversations}
              formatDate={this.formatDate}
              openUserChat={this.openUserChat}
              isGroup={true}
            />
          )}

        </div>
      </React.Fragment>
    );
  }
}

export default Chats;
